import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

export function ValidationErrors({ errors }) {
  if (errors.length === 0) return null;

  return (
    <ul className="text-xs list-inside">
      {errors.map((error, index) => (
        <li key={index} className="flex items-center gap-1.5">
          <ExclamationCircleIcon className="size-5 text-coral-400 shrink-0" />
          <span>{error}</span>
        </li>
      ))}
    </ul>
  );
}
